import './style/heroImage.css'
import reactDom from 'react-dom';

const HeroImage = (props) => {
    const renderBullet = props.bullets.map((x, i) => <p key={i} className="item">{x}</p>)

    return reactDom.createPortal(
        <div className="hero-image-container" style={{backgroundImage: `${window.getComputedStyle(document.body).getPropertyValue('--main-image-gradiant')}, url(${props.src})`}}>
        <div className="ui container content">
            <div className="main-title">
                <h1>{props.mainTitle}</h1>
            </div>
            <div className="bullet-points">
                <div className="ui bulleted list">
                    {renderBullet}
                </div>
            </div>
        </div>
        </div>,
        document.getElementById('main-image')
    )
}
export default HeroImage
